import { MANAGEMENT_CANCEL_TEXT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import {
    MANAGEMENT_SF_DISCONNECT_MODAL_DESCRIPTION,
    MANAGEMENT_DISCONNECT_MODAL_TITLE,
} from "app/pages/sales-intelligence/pages/management/translations/modals";
import { MANAGEMENT_SF_DISCONNECT_TOOLTIP } from "app/pages/sales-intelligence/pages/management/translations/salesforceKeys";
import { CUSTOM_DISCONNECT_STYLES, StyledDeleteModalHeader, StyledReplaceModalText } from "../../../styles/modal";
import type { ModalProps } from "./types";
import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { translate } from "app/filters/i18nFilter";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";

export default function DisconnectModal({ integrationName, isOpen, onConfirm, onClose }: ModalProps) {
    return (
        <ManagementModal
            customStyles={CUSTOM_DISCONNECT_STYLES}
            confirmBtnText={MANAGEMENT_SF_DISCONNECT_TOOLTIP}
            title={
                <StyledDeleteModalHeader>
                    <StyledReplaceModalText>
                        {translate(MANAGEMENT_DISCONNECT_MODAL_TITLE, {
                            integrationName: getCrmName(integrationName),
                        })}
                    </StyledReplaceModalText>
                </StyledDeleteModalHeader>
            }
            details={translate(MANAGEMENT_SF_DISCONNECT_MODAL_DESCRIPTION)}
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onClose}
            cancelBtnText={MANAGEMENT_CANCEL_TEXT}
            confirmBtnType="warning"
            cancelBtnType="flatDark"
        />
    );
}
